import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { DOMICILIO_FISCAL } from '../../../common/types/tipoEstablecimientoType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';
import unidadMedidaService from '../../../service/administracion/unidadMedidaService';


import recetaService from '../../../service/logistica/recetaService';
import productoService from '../../../service/administracion/productoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import FormView from './FormView';

import BuscarProductoModal from './BuscarProductoModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            productoVisible: false,
            loadingPrint: false,
            visibleView: false,
            productos: [],
            estados: estadoMock.values,
            filter: {
                idProducto: 0,
                idEstado: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            activeKey:"1",
            id: 0,
            idProducto: 0,
            serie: 'RC01',
            nombreUnidadMedida: '',
            documento: '',
            descripcion: '',
            productos: [],
            listaComprobanteDetalle: [],
            unidadesMedida: []
        }
    }

    handleClearFilters = async () => {
        var filter = {
            idProducto: 0,
            idEstado: 0,
            ...FILTER
        };
        this.setState({ filter });
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await recetaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if(response !== undefined)
            global.dowloadFile(response.data, "Reporte de Establecimiento.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await recetaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Establecimiento.pdf");
    }


    handlePrint = async (row) => {
        debugger
        this.setState({ loadingPrint: true });
        var response = await recetaService.pdfA4(row.id);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            //win.focus();
        }
    }

    handleDeleteActive = (values) => {
        var nro_documento=values.serie+"-"+ values.documento;
        var sms = values.codRecetaEstado == "I" ? "Desea habilitar la receta " + nro_documento+ " ?": "Desea deshabilitar la receta " + nro_documento+" ?";
        dialog.confirm(sms, async () => {
          
           var response = await recetaService.actualizarEstado(values);
            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.productos = this.state.productos;
       // formValues.unidadesMedida= this.state.unidadesMedida;
        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        debugger
        var regg = new Object();
        var dato =undefined;
        var listasMedida= [];

        const responseDetalle = await recetaService.obtenerDetallePorId(values.id);

        var formValues = this.fetchEmptyFormValues();
        formValues.id = values.id;
        formValues.idProducto = values.idProducto;
        formValues.serie = values.serie;
        formValues.documento = values.documento;
        formValues.descripcion = values.descripcion;
        formValues.listaComprobanteDetalle = [];

        formValues.productos = this.state.productos;
        responseDetalle.forEach(item => {

            formValues.listaComprobanteDetalle.push({
                identifier: global.fetchUniqueCode(),
                idProducto: item.idProducto,
                nombre: item.nombre,
                cantidad: item.cantidad,
                idUnidadMedida: item.idUnidadMedida,
                codigo: item.codigoReferencia,
                nombreUnidadMedida: ''
            })
            if(item.authorsList.length > 0 ){
                item.authorsList.forEach(regg => {

                    dato = this.state.unidadesMedida.filter(unidades => unidades.id == regg);
                    regg = new Object();
                    regg.codigoSunat = dato[0].codigoSunat;
                    regg.flagSunat = dato[0].flagSunat;
                    regg.id = dato[0].id;
                    regg.nombre = dato[0].nombre;
                    regg.idProducto =  item.idProducto;
        
                    listasMedida.push(regg);
                })
            }else{

                dato = this.state.unidadesMedida.filter(unidades => unidades.id == item.idUnidadMedida);

                regg = new Object();
                regg.codigoSunat = dato[0].codigoSunat;
                regg.flagSunat = dato[0].flagSunat;
                regg.id = dato[0].id;
                regg.nombre = dato[0].nombre;
                regg.idProducto =  item.idProducto;
    
                listasMedida.push(regg);
            }




        });
        formValues.unidadesMedida = listasMedida;

        this.setState({ visible: true, formValues: formValues });

        
    };

    handleChangeForm = async (property, value,row,index) => {
debugger
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== row.identifier);
        var item=undefined;
        if (property === "arridUnidadMedida") {

            item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.idProducto,
                nombre: row.nombre,
                cantidad: row.cantidad,
                idUnidadMedida: value,
                codigo: row.codigoReferencia,
                nombreUnidadMedida: ''
            }
        }

        if (property === "arrCantidad") {
   
            item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.idProducto,
                nombre: row.nombre,
                cantidad: (parseFloat(value)).toFixed(2),
                idUnidadMedida: row.idUnidadMedida,
                codigo: row.codigoReferencia,
                nombreUnidadMedida: ''
            }
        }
        if (property === "arrTerminado") {
   
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    nombreUnidadMedida: this.state.productos.filter(pro => pro.id == value)[0].nombreUnidadMedida,
                }
            });
            return false;
        }

        listaComprobanteDetalle.splice(index, 0, item);

        
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle,
            }
        });

    };

    handleAgregarDetalle = async () => {
        debugger
        var productos = await productoService.listarPorRequeremiento(1);

        this.setState({
            productoVisible: true,
            productoModal: {
                ...this.state.productoModal,
                dataSource: productos,
                selectedRowKeys: this.state.formValues.listaComprobanteDetalle.map(function (v) {
                    return v.idProducto;
                  })
            },
            
         
        });

   
    };

    handleView = async (values) => {
        debugger
        var regg = new Object();
        var dato =undefined;
        var listasMedida= [];

        const responseDetalle = await recetaService.obtenerDetallePorId(values.id);

        var formValues = this.fetchEmptyFormValues();
        formValues.id = values.id;
        formValues.idProducto = values.idProducto;
        formValues.serie = values.serie;
        formValues.documento = values.documento;
        formValues.descripcion = values.descripcion;
        formValues.listaComprobanteDetalle = [];

        formValues.productos = this.state.productos;
        responseDetalle.forEach(item => {

            formValues.listaComprobanteDetalle.push({
                identifier: global.fetchUniqueCode(),
                idProducto: item.idProducto,
                nombre: item.nombre,
                cantidad: item.cantidad,
                idUnidadMedida: item.idUnidadMedida,
                codigo: item.codigoReferencia,
                nombreUnidadMedida: this.state.unidadesMedida.filter(unidades => unidades.id == item.idUnidadMedida)[0].nombre,

            })
        });
        formValues.unidadesMedida = listasMedida;

        this.setState({ visibleView: true, formValues: formValues });

        
    };


    
    handleChangeProductoModal = (value) => {
        const dataSource = this.state.productos.filter(item => {
            return (item.codigoReferencia + ' - ' + item.nombre)
                .toUpperCase()
                .match(value.toUpperCase());
        });

        this.setState({
            productoModal: {
                ...this.state.productoModal,
                dataSource: dataSource
            }
        });
    };

    
    handleChangeSelectedRowKey = async(selected, rows) => {
        debugger
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var listasMedida= [];
        var regg = new Object();
        var item =undefined;
        var contador=0;
        rows.forEach( async param => {

            const productosConversion = await productoService.listarConversionProductoPorId(param.id);

            if (productosConversion.length > 0) {

                productosConversion.forEach(element => {
                    item = this.state.unidadesMedida.filter(unidades => unidades.id == element.idUnidadMedida)

                    regg = new Object();
                    regg.codigoSunat = item[0].codigoSunat;
                    regg.flagSunat = item[0].flagSunat;
                    regg.id = item[0].id;
                    regg.nombre = item[0].nombre;
                    regg.idProducto = element.idProducto;
                    listasMedida.push(regg);

                });

                item = this.state.unidadesMedida.filter(unidades => unidades.nombre == param.nombreUnidadMedida)
                regg = new Object();
                regg.codigoSunat = item[0].codigoSunat;
                regg.flagSunat = item[0].flagSunat;
                regg.id = item[0].id;
                regg.nombre = item[0].nombre;
                regg.idProducto = param.id;
                listasMedida.push(regg);

            } else {
              
                item = this.state.unidadesMedida.filter(unidades => unidades.nombre == param.nombreUnidadMedida)
                regg = new Object();
                regg.codigoSunat = item[0].codigoSunat;
                regg.flagSunat = item[0].flagSunat;
                regg.id = item[0].id;
                regg.nombre = item[0].nombre;
                regg.idProducto = param.id;
                listasMedida.push(regg);
            }
             contador++;

            if (rows.length == contador) {


                rows.forEach(item => {
                    var filter = this.state.formValues.listaComprobanteDetalle.filter(m => { return m.idProducto === item.id; });
                    if (filter.length === 0) {
                        
                        listaComprobanteDetalle.push({
                            identifier: global.fetchUniqueCode(),
                            idProducto: item.id,
                            nombre: item.nombre,
                            cantidad: 0,
                            idUnidadMedida: this.state.unidadesMedida.filter(e => e.nombre === item.nombreUnidadMedida)[0].id,
                            codigo: item.codigoReferencia,
                            nombreUnidadMedida: item.nombreUnidadMedida
                        })
                    }
                });

                listaComprobanteDetalle = listaComprobanteDetalle.filter(m => selected.filter(f => f === m.idProducto).length);

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaComprobanteDetalle: listaComprobanteDetalle,
                        unidadesMedida: listasMedida
                    },
                    productoModal: {
                        ...this.state.productoModal,
                        selectedRowKeys: selected
                    }
                });

            }
        });

    };

    
    handleRemoverProducto = (id) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto !== id);
        var selectedRowKeys = this.state.productoModal.selectedRowKeys.filter(m => m !== id);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selectedRowKeys
            }
        });
    };
    
    handleBuscarProducto = async () => {
        //000001 BIENES // 000002 SERVICIO
        var productos = await productoService.listarPorRequeremiento(1);
        
        this.setState({
            productoVisible: true,
            productoModal: {
                ...this.state.productoModal,
                dataSource: productos,
                selectedRowKeys: []
            },
         
        });
    }



    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await recetaService.registrar(values);
            else
                response = await recetaService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false});
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, recetaService.paginacion);
        const unidadesMedida = await unidadMedidaService.listar();

        const productos = await productoService.listar();
        const productos_filter = productos.filter(m => m.idTipoProducto === 1);
        this.setState({
            loadingSource: false,
            productos: productos_filter ? productos_filter : [],
            unidadesMedida: unidadesMedida ? unidadesMedida : [],

        });
    };

    render() {
        return (
            <div>
                <Header
                    title="Receta de Producción"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    productos={this.state.productos}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onImprimir={this.handlePrint}
                    onEdit={this.handleEdit}
                    onView={this.handleView}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onChange={this.handleChangeForm}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onClose={() => this.setState({ visible: false })}
                    onRemoverProducto={this.handleRemoverProducto}

                    onSave={this.handleSave}
                />

                <BuscarProductoModal
                    visible={this.state.productoVisible}
                    formValues={this.state.productoModal}
                    onChange={this.handleChangeProductoModal}
                    onChangeRow={this.handleChangeSelectedRowKey}
                    onSearch={this.handleBuscarProducto}
                    onCancel={() => this.setState({ productoVisible: false })}
                />

              <FormView
                    visible={this.state.visibleView}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visibleView: false })}
                />
            </div>
        );
    };
}